import { MsalAuthProvider, LoginType } from "react-aad-msal";
const config = {
  auth: {
    authority: process.env.REACT_APP_AUTHORITY_URL,
    clientId: process.env.REACT_APP_AUTH_CLIENT_ID,
    redirectUri: process.env.REACT_APP_LANDING_PAGE_URL,
    // authority:"https://login.microsoftonline.com/abhishekchauhan101786gmail.onmicrosoft.com",
    // clientId: "fe96b775-6eac-4dec-a739-9a8332d67e05",
    // redirectUri: "http://localhost:3001/",
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
};

const authenticationParameters = {
  scopes: ["user.read"],
};

const options = {
  loginType: LoginType.Redirect,
  tokenRefreshUri: window.location.origin + "/auth.html",
};

export const authProvider = new MsalAuthProvider(
  config,
  authenticationParameters,
  options
);
